import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'

const Image = styled(Img)`
  box-shadow: 0px 15px 50px 0px rgba(0, 0, 0, 0.75);
  background-color: transparent;
  border-radius: 6.5%;
`
const ReportImage = ({ alt }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "Report.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Image alt={alt} fluid={data.placeholderImage.childImageSharp.fluid} />
}

export default ReportImage
